import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import CaretLeft from 'svg/caret-left.svg'
import CaretRight from 'svg/caret-right.svg'
import Rewind from 'svg/rewind.svg'
import Share from 'svg/share-icon.svg'
import Pencil from 'svg/pencil-new.svg'

// Icons
const IconStyle = (props) => `
  height: 35px;
  width: 35px;
  overflow: visible;
  path {
    stoke: #ffffff;
    stroke-width: 2px;
  }
`

export const Layout = styled.div`
  display: flex;
  flex-direction: row;
  //margin: 50px auto 100px 115px;
  margin: 0px auto;
  margin-top: 50px;
  padding: 0 16px;
  font-size: 16px;
  color: #333333;
  max-width: 1300px;
  width: 100%;
  text-align: center;
  hr {
    border: none;
    border-top: 1px solid #dcdcdc;
    margin: 0;
  }
  [data-section='user-info-section'] {
    margin-right: 40px;
    //margin-left: 80px;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    [data-type='divider-line'] {
      margin-top: 24px;
    }
    [data-type='user-name'] {
      font-weight: bold;
      color: #000000;
      overflow-wrap: break-word;
      margin-top: 28px;
      margin-bottom: 0;
    }
    [data-type='share-follow-row'] {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    [data-section='share-icons-section'] {
      [data-type='share-button'] {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: none;
        border: 1px solid #dcdcdc;
        width: 45px;
        height: 45px;
        cursor: pointer;
        margin-top: 24px;
        margin-bottom: 4px;
        padding: 0;
        [data-type='share-text'] {
          text-transform: uppercase;
          font-size: 9px;
          margin: 0;
          letter-spacing: 0.1em;
          color: #333333;
        }
        @media (min-width: 992px) {
          &:hover {
            background: #333333;
            [data-type='share-text'] {
              color: #ffffff;
            }
            svg {
              path {
                fill: #ffffff;
              }
            }
          }
        }
        &[data-style] {
          background: #333333;
          [data-type='share-text'] {
            color: #ffffff;
          }
          svg {
            path {
              fill: #ffffff;
            }
          }
        }
      }
      [data-type='social-icons'] {
        min-height: 65x;
        width: 65px;
        z-index: 1;
        display: flex;
        position: absolute;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        [data-type='pinterest-link'],
        [data-type='twitter-link'],
        [data-type='email-link'],
        [data-type='facebook-link'] {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 38px;
          width: 45px;
          padding-right: 13px;
          padding-left: 13px;
          background-color: #333333;
          // &:hover {
          //   border-bottom: 2px solid #ffffff;
          // }
        }
      }
    }
    [data-type='user-location-section'] {
      display: flex;
      justify-content: flex-start;
      margin-top: 24px;
      [data-type='user-location'] {
        font-size: 16px;
        letter-spacing: -0.02em;
        color: #666666;
        margin: 0;
        text-align: left;
      }
      [data-type='flag-icon'] {
        background: url('https://d3t95n9c6zzriw.cloudfront.net/common/sprite-flag-3.png') no-repeat
          top left;
        background-size: 558px 1009px;
        cursor: default;
        display: block;
        float: left;
        height: 22px;
        margin: 2px 10px 5px 0;
        width: 30px;
      }
    }
    [data-type='user-following'] {
      font-size: 16px;
      letter-spacing: -0.02em;
      color: #666666;
      display: inline-block;
      margin-top: 24px;
      text-decoration: none;
      [data-type='count'] {
        font-weight: bold;
        color: #333333;
      }
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    [data-section='user-about-section'] {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      [data-type='user-about-title'] {
        font-size: 18px;
        line-height: 25px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #000000;
        margin-top: 24px;
        margin-bottom: 0;
      }
      [data-type='user-about-text'] {
        font-size: 16px;
        line-height: 22px;
        letter-spacing: -0.02em;
        color: #333333;
        margin-top: 16px;
        margin-bottom: 24px;
        text-align: left;
      }
      [data-type='view-more-button'] {
        font-weight: bold;
        font-size: 12px;
        line-height: 16px;
        text-decoration-line: underline;
        text-transform: uppercase;
        color: #333333;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
      }
    }
    [data-section='admin-panel'] {
      margin-top: 20px;
      width: 100%;
      border: 1px solid #dcdcdc;
      padding: 20px;
      h2 {
        margin: 0px;
        font-style: italic;
        font-weight: normal;
        font-size: 22px;
        text-align: left;
      }
      p {
        margin-top: 10px;
        overflow-wrap: anywhere;
        text-align: left;
        span {
          font-weight: bold;
        }
        a {
          text-decoration: none;
          color: #333333;
          &:hover {
            color: #000000;
          }
        }
      }

      @media (max-width: 992px) {
        max-width: 100%;
      }
    }
  }
  [data-section='fav-col-section'] {
    display: flex;
    flex-direction: column;
    [data-section='collection-section'] {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      min-height: 200px;
      [data-type='main-title'] {
        margin-bottom: 32px;
        color: #000000;
        text-transform: uppercase;
      }
      [data-type='view-all'] {
        text-decoration: none;
        display: flex;
        margin: 32px 0px;
        height: 53px;
        align-items: center;
        justify-content: center;
        max-width: 343px;
        white-space: nowrap;
        background: #da3b1f;
        border: none;
        color: #fff;
        font-weight: bold;
        width: 100%;
      }
      [data-type='collection-tiles'] {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        [data-type='tile'] {
          margin-right: 8px;
          margin-bottom: 8px;
          position: relative;
          max-width: 156px;
          width: 100%;
          [data-type='image'] {
            display: block;
            width: 156px;
            height: 156px;
          }
          [data-type='title'] {
            margin-top: 60px;
            color: #ffffff;
            text-align: center;
            display: block;
            padding: 0px 10px;
            font-weight: bold;
            font-size: 16px;
            line-height: 16px;
          }
          [data-type='artwork-count'] {
            color: #ffffff;
            text-align: center;
            display: block;
            padding: 0px 10px;
            font-weight: bold;
            font-size: 16px;
            line-height: 16px;
            margin-top: 5px;
          }
          [data-type='overlay'] {
            position: absolute;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            width: 100%;
            height: 100%;
            text-align: center;
          }
        }
      }
    }
  }
  [data-type='favorites-section'] {
    max-width: 980px;
    min-height: 380px;
    display: block;
    text-align: left;
    [data-type='main-title'] {
      margin-bottom: 32px;
      color: #000000;
      text-transform: uppercase;
    }
    [data-type='view-all'] {
      text-decoration: none;
      display: flex;
      margin-bottom: 32px;
      height: 53px;
      align-items: center;
      justify-content: center;
      max-width: 343px;
      white-space: nowrap;
      background: #da3b1f;
      border: none;
      color: #fff;
      font-weight: bold;
    }
    [data-type='controls'] {
      width: 100%;
      position: relative;
      button {
        cursor: pointer;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 75px;
        background: transparent;
        border: none;
        &:focus {
          outline: none;
        }
        &[data-action='previous'] {
          left: -50px;
        }
        &[data-action='next'] {
          right: -50px;
        }

        @media (max-width: 992px) {
          display: none;
        }
      }
    }

    [data-type='carousel'] {
      display: flex;
      width: 100%;
      overflow-x: hidden;
      overflow-y: hidden;
      @media (max-width: 992px) {
        overflow-x: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
    [data-section='artwork-info'] {
      font-size: 16px;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
      [data-type='actions'] {
        display: flex;
        flex-direction: row;
        [data-action='cart'] {
          width: 30px;
          height: 24px;
          padding: 0;
          margin: 0;
          background: transparent;
          path {
            stroke: unset;
          }
          &:hover {
            path {
              fill: #77c054;
            }
          }
        }
        [data-type='action']:first-child {
          width: 30px;
          height: 24px;
          padding: 0;
          margin: 0;
          background: transparent;
          svg {
            path {
              fill: #ffffff;
            }
            &[data-favorite='favorite'] {
              path {
                fill: #ef542c;
              }
            }
          }
          &:hover {
            path {
              stroke: #ef542c;
              fill: #ef542c;
            }
          }
        }
      }

      [data-type='artwork-title'] {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #333333;
      }
      [data-type='artist-name'] {
        text-decoration: none;
      }
      [data-type='artist-name'],
      [data-type='price'] {
        color: #666666;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    ul {
      display: block;
      width: 100%;
      min-height: 300px;
      margin-block-start: 0px;
      margin-block-end: 0px;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 0px;
      list-style: outside none none;
      margin: 0px;
      padding: 0px;
      white-space: nowrap;
      transform: translate3d(0px, 0px, 0px);
      transition: 0.2s ease transform;
      will-change: transform;
      @media (max-width: 992px) {
        min-height: 280px;
      }
    }

    li {
      display: inline-flex;
      justify-content: center;
      align-items: flex-start;
      width: 156px;
      height: 100%;
      vertical-align: top;
      list-style: outside none none;
      margin: 0px;
      padding: 0px;
      overflow: hidden;
      &:not(:last-child) {
        margin-right: 8px;
      }
      [data-type='artwork'] {
        width: 156px;
      }
      img {
        width: 156px;
      }
      p {
        margin: 0;
      }
      @media (max-width: 992px) {
        width: 156px;
        [data-type='artwork'],
        img {
          width: 156px;
        }
        &:not(:last-child) {
          margin-right: 8px;
        }
      }
    }
    @media (max-width: 1350px) {
      max-width: 650px;
    }
  }
  @media (max-width: 992px) {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    [data-section='user-info-section'] {
      max-width: 100%;
      width: 100%;
      margin-right: 0;
      margin-left: 0;
      [data-type='avatar-section'] {
        [data-type='user-avatar'] {
          width: 100px;
          height: 100px;
        }
      }
      [data-section='share-icons-section'] {
        [data-type='social-icons'] {
          width: 45px;
        }
      }
      [data-type='user-location-section'] {
        justify-content: center;
        align-items: center;
        [data-type='user-location'] {
          margin-top: -2px;
        }
      }
      [data-section='user-about-section'] {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        [data-type='user-about-text'] {
          text-align: left;
          width: 100%;
        }
      }
    }
    [data-section='fav-col-section'] {
      width: 100%;
      [data-section='collection-section'] {
        [data-type='collection-tiles'] {
          overflow-x: auto;
          flex-wrap: nowrap;
          &::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }
    [data-type='favorites-section'] {
      max-width: 100%;
    }
  }
`
export const NextIcon = styled(CaretRight)`
  ${(props) => IconStyle(props)};
`
export const PrevIcon = styled(CaretLeft)`
  ${(props) => IconStyle(props)};
`
export const RewindIcon = styled(Rewind)`
  width: 16px;
  height: 16px;
  overflow: visible;
`
export const ShareIcon = styled(Share)`
  fill: #fff;
  height: 25px;
`
export const PencilIcon = styled(Pencil)`
  position: absolute;
  left: 20px;
  top: 20px;
  width: 19px;
  height: 19px;
`
